export function getSorter<T> (field: keyof T): (a: T, b: T) => number {
  return function (a: T, b: T) {
    if (a[field] > b[field]) return 1;
    if (a[field] < b[field]) return -1;
    return 0
  }
}